import { createUseQuery } from 'api/common/createUseQuery'
import { fetchCommunityTags } from 'api/fetchers/fetchCommunityTags'
import { ApiQueryKeys } from 'constants/apiQueryKeys'
import { CommunityTag } from 'types/community-tags'

export const useCommunityTags = createUseQuery({
  queryKey: ApiQueryKeys.COMMUNITY_TAGS,
  fetcher: fetchCommunityTags,
  selector: res => (res?.data as CommunityTag[] | undefined) ?? ([] as CommunityTag[]),
})
